import React, { useEffect } from 'react';
import { withRouter } from "react-router-dom";
import Helper from '../../common/Helper';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';
import APIURLConstants from '../../common/ApiURLConstants';
import { authenticationService } from '../../services';
import RouteConstants from '../../common/RouteConstants';

const ReLogin = (props) => {
    const { instance } = useMsal();
    useEffect(() => {
        const logout = async () => {
             authenticationService.logout()
                .then(async res => {
                    console.log("Logout successful:", res);
                    window.location.href = RouteConstants.OFFICIAL_LOGIN;

                }).catch(err => {
                    console.log("Logout error:", err);
                });
           // var accesstoken = localStorage.getItem('accessToken')
            //if (accesstoken && accesstoken !== "") {
                // axios.get(APIURLConstants.SIGNOUT) //, { headers: { 'Authorization': `Bearer ${accesstoken}` } }
                //     .then(async res => {
                //         //if (Helper.getStorage('chk') == 'aad') {
                //           //  localStorage.clear()
                //             await instance.logoutRedirect();

                //        // }

                //         Helper.ReLogin();

                //     })
            //} else {
            //    window.location.href = '/';
           // }
        }
        logout();
    }, [])

    return (
        <></>
    );
}

export default withRouter(ReLogin);